import {CLEAR_SITE_ELEMENTS, RESET_STEP1_VALIDATION, RESET_STEP2_VALIDATION, RESET_WIZARD_CACHE} from "../types";


export const clearCache = () => dispatch => {
    dispatch({
        type: CLEAR_SITE_ELEMENTS,
        payload: null
    });
    dispatch({
        type: RESET_STEP2_VALIDATION,
        payload: null
    });
    dispatch({
        type: RESET_STEP1_VALIDATION,
        payload: null
    });
    dispatch({
        type: RESET_WIZARD_CACHE,
        payload: null
    })
}



// WEBPACK FOOTER //
// ./src/actions/WizardActions/ClearChache.js